// ABOUTME: 2A's storm sky: a grey-blue wash over the feeling sky with 1A's storm clouds on the left and its sun breaking through on the right.
// ABOUTME: Static by design; it fills the feeling sky box and is drawn on the feeling scene's 850px stage so it scales with it.

import { Box } from '@mui/material';
import { CROSSING_BREATH_SUN, CROSSING_FEELING_STORM_OVERLAY } from '../../../../theme/crossingTokens';
import { useFrameScale } from '../../crossing/useFrameScale';
import { useHorizon } from '../../crossing/useHorizon';
import { CLOUD_SHAPES, STORM_LAYER_CLOUDS } from '../../crossing/stormSkyParts';
import { FEELING_PLATE_WIDTH, STAGE_WIDTH } from './feelingCopyLayout';

// Each cloud's centre as a fraction of the stage, in STORM_LAYER_CLOUDS order: left of the stage's centre, and clear of the
// feeling's name (stage x 275 to 575) except the third, which sits below the name's band. Tops are STORM_LAYER_CLOUDS' own, except
// the third, which drops under the name so the dark ink never sits on cloud.
const CLOUD_CENTRES = [0.18, 0.15, 0.46, 0.12];
const CLOUD_TOPS = ['44%', '30%', '72%', '40%'];
const SUN_CENTRE = 0.58;
const SUN_SIZE = 60;
const SUN_TOP = '68%';

// Fills its parent, the feeling sky box, which is as tall as the horizon line.
export default function FeelingStormSky() {
  const { frameSc } = useFrameScale(FEELING_PLATE_WIDTH);
  const { line } = useHorizon();
  return (
    <>
      <Box data-testid="feeling-storm-overlay" sx={{ position: 'absolute', inset: 0, backgroundColor: CROSSING_FEELING_STORM_OVERLAY }} />
      <Box
        sx={{
          position: 'absolute', left: '50%', top: 0, width: STAGE_WIDTH, height: `${line / frameSc}px`, marginLeft: `${-STAGE_WIDTH / 2}px`,
          transform: `scale(${frameSc})`, transformOrigin: '50% 0',
        }}
      >
        <Box
          data-testid="feeling-storm-sun"
          sx={{
            position: 'absolute', left: `${SUN_CENTRE * 100}%`, top: SUN_TOP, width: `${SUN_SIZE}px`, height: `${SUN_SIZE}px`,
            transform: 'translateX(-50%)', borderRadius: '50%', background: CROSSING_BREATH_SUN,
          }}
        />
        {STORM_LAYER_CLOUDS.map((cloud, index) => (
          <Box
            key={cloud.fill}
            data-testid="feeling-storm-cloud"
            style={{ opacity: cloud.opacity }}
            sx={{
              position: 'absolute', left: `${CLOUD_CENTRES[index] * 100}%`, top: CLOUD_TOPS[index], width: `${cloud.width}px`, height: `${cloud.height}px`,
              transform: 'translateX(-50%)',
            }}
          >
            {CLOUD_SHAPES.map(shape => (
              <Box key={shape.left} sx={{ position: 'absolute', ...shape, background: cloud.fill }} />
            ))}
          </Box>
        ))}
      </Box>
    </>
  );
}
